import { render, staticRenderFns } from "./ShopeeReportProfitLoss.vue?vue&type=template&id=2486e087&scoped=true"
import script from "./ShopeeReportProfitLoss.vue?vue&type=script&lang=js"
export * from "./ShopeeReportProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./ShopeeReportProfitLoss.vue?vue&type=style&index=0&id=2486e087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486e087",
  null
  
)

export default component.exports